import axios from 'axios';

async function contactAddLimitExceeded() {
  try {
    const limitExceeded = await axios.get('/plan/contact-limit');
    return limitExceeded?.data?.exceeded ? limitExceeded.data.exceeded : false;
  } catch (error) {
    return false;
  }
}

export default contactAddLimitExceeded;
